import store from "../store";
// 列表
const list =  store("list", {});

export default{    
    list
}



// WEBPACK FOOTER //
// ./src/vuex/modules/level2.js